<template>
    <div>
        <div class="blue-line"></div>
        <div class="project-card">
            <div class="project-card-title"
                @click="followLink"
            >{{ title | shortName(maxChar) }}</div>
            <div class="project-card-date">Last Updated: {{ update | dateFormatter}}</div>
            <span>
                    <button
                            v-if="buttons"
                            type="button"
                            class="vcore_btn round-button red-button"
                            @click="$emit('delete', title, path)"
                    >
                        <i class="vcore_icon icon-close"></i>
                    </button>
                    <button
                            v-if="buttons"
                            type="button"
                            class="vcore_btn round-button blue-button"
                            @click="edit"
                    >
                        <i class="vcore_icon icon-edit"></i>
                    </button>
            </span>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";

    export default {
        name: "ProjectCard",
        methods: {
            ...mapActions([

            ]),
            edit() {
                this.$router.push("/edit/" + this.path);
            },
            followLink(){
                window.location.href = this.link;
            }
        },
        props: {
            title: {
                type: String,
            },
            update: {
                type: Number,
            },
            path: {
                type: String,
            },
            url: {
                type: String
            },
            buttons: {
                type: Boolean
            }
        },
        data(){
            return {
                link: this.url + this.path
            }
        },
        computed: {
            ...mapGetters([
                "totalWidth"
            ]),
            maxChar: function(){
                if(this.totalWidth < 440 ) { return this.totalWidth / 20; }
                if(this.totalWidth < 768 && this.totalWidth >= 440) { return this.totalWidth / 16; }
                if(this.totalWidth < 992 && this.totalWidth >= 768 ) { return this.totalWidth / 33; }
                if(this.totalWidth < 1200 && this.totalWidth >= 992) { return this.totalWidth / 33; }
                if(this.totalWidth < 1400 && this.totalWidth >= 1200) { return this.totalWidth / 45; }
                if(this.totalWidth >= 1400) { return this.totalWidth / 40;}
                return this.totalWidth / 15;
            },
        },
    }
</script>

<style scoped lang="scss">

    .blue-line {
        background-color: #2b78e4;
        height: 5px;
        width: 100%;
    }

    .project-card {
        background-color: white;
        text-align: start;
        padding: 12px;
    }

    .project-card-title {
        color: #2b78e4;
        font-size: 24px;
        margin-bottom: 8px;
        cursor: pointer;
        width: fit-content;
    }

    .project-card-date {
        color: #666666;
        font-size: 14px;
    }

    .vcore_btn {
        float: right;
        margin-left: 5px;
    }

    .round-button {
        width: 36px;
        height: 36px;
        border-radius: 100%;
        font-size: 18px;
        position: relative;
        left: 8px;
        margin-left: 8px;
        bottom: 8px;
        text-align: center;
    }

</style>
